import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";
import { ForgotPwd } from "../models/forgotpwd";
import { APIResponse } from "src/app/utils/models/response";
import { numberSymbols } from "@progress/kendo-angular-intl";

@Injectable({
  providedIn: 'root'
})
export class ForgotpwdService{
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'authenticate/ret/hCw230b862-99250-4f71-a1271-f8bqxvvbner121967d35d/candidate/AOaemvOPybXzswaLnMtcT3gMn3sp3/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }



  checkDuplication(UserName?: string,UserId?: number): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?UserName=' + (UserName ? UserName : '')+ '&UserId=' + (UserId ? UserId : 0)).pipe(map((result: any) => {
        return result;
    }));
  }
  viewDetails(UserName?: string): Observable<Array<ForgotPwd>> {
    return this.httpService.get(this.apiEndpoint + 'viewDetails?UserName='+ (UserName ? UserName : '')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  generateOtp(UserId?: number): Observable<APIResponse> {
    return this.httpService.get(this.apiEndpoint + 'generateOtp?UserId=' + (UserId ? UserId : '')).pipe(map((response: APIResponse) => {
      return response;
    }));
  }

  validateOtp(otp?: number, UserId?: number): Observable<Array<ForgotPwd>> {
    return this.httpService.get(this.apiEndpoint + 'validateOtp?Otp=' + (otp ? otp : '')+ '&UserId=' + (UserId ? UserId : 0)).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  saveNewPassword(UserName?: string,NewPassword?: string): Observable<APIResponse>  {
    return this.httpService.get(this.apiEndpoint + 'saveNewPassword?UserName=' + (UserName ? UserName : '')+ '&NewPassword=' + (NewPassword ? NewPassword: '')).pipe(map((result: any) =>  {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }


  savePassword(UserName?: string,password?: string): Observable<APIResponse> {
    return this.httpService.get(this.apiEndpoint + 'savePassword?UserName=' + (UserName ? UserName : '')+ '&password=' + (password ? password: '')).pipe(map((result: any) =>  {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  checkCurrentPassword(UserName?:string,OldPassword ?:string): Observable<APIResponse>{
    return this.httpService.get(this.apiEndpoint + 'checkCurrentPassword?UserName='+ (UserName ? UserName :'')+'&OldPassword=' + (OldPassword ? OldPassword :'')).pipe(map((result : any)=> {
       return result.Data;
    }
  ));
}

}
